import * as React from "react";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import FilterContext from "./context/Filter";

const OptionRow = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const ctx = React.useContext(FilterContext);

  return (
    <div
      className={`vm-border-b vm-text-xl vm-p-4 vm-bg-white ${
        isDragging ? "vm-shadow-xl vm-z-10" : ""
      }`}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <div className="vm-flex vm-items-center">
        <svg
          className="vm-w-5 vm-h-5 vm-mr-2 vm-text-gray-400 vm-cursor-move"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <span className="vm-flex-1">{props.option.title}</span>
        <span className="vm-font-mono vm-text-sm">
          {ctx.data.title}:{props.option.slug}
        </span>
      </div>
    </div>
  );
};

export default OptionRow;
